import React, { useEffect, useState, useRef } from 'react';

import renderHTML from 'react-render-html';
import { Redirect, useParams, useRouteMatch } from 'react-router-dom';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';

import appContent from 'helpers/appContent';

import RetainContent from 'views/RetainContentView/RetainContent';
import Sidebar from 'views/RetainContentView/Sidebar';

import {
  LinkButton,
} from 'C4';

const getPages = async ({ chapterId }, callback) => {
  callback(await APIHandler.getTrainingPages(chapterId));
};

const getChapters = async (callback) => {
  const { app: chapters } = (await APIHandler.getChapters(DataHandler.matchAppIdSync())) || {};
  callback(chapters);
};

const switchPage = (key, { pageId, total }, callback) => {
  let redirect = +pageId;

  if (key === 'ArrowDown') redirect = redirect < total ? redirect + 1 : 0;
  if (key === 'ArrowUp') redirect = redirect === 0 ? total : redirect - 1;

  callback(+redirect);
};

const RetainContentView = () => {
  const { params, path } = useRouteMatch();
  const { chapterId, pageId } = useParams();

  const [items, setItems] = useState([]);
  const [pages, setPages] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [redirect, setRedirect] = useState(null);

  const pageIdRef = useRef(pageId);

  const redir = useRef((newPageId) => {
    setRedirect(
      Object.keys(params).reduce(
        (acc, key) => acc.replace(new RegExp(`/:${key}`), `/${{ type: params.type, chapterId, pageId: newPageId }[key]}`),
        '/main/:type/:chapterId/:pageId',
      ),
    );
  });

  useEffect(() => {
    if (chapters.length === 0) getChapters(setChapters);
    if (pages.length === 0) getPages({ chapterId }, setPages);

    if (items.length === 0 && pages.length > 0) {
      setItems(
        pages
          .filter(({ pageType }) => pageType !== undefined && pageType !== 'Final-Page')
          .map(({ title, pageType: type, upID }, i) => ({
            upID,
            index: i,
            name: title || type,
            type,
          })),
      );
    }
  }, [chapterId, chapters.length, items, pageId, pages, params, path]);

  useEffect(() => {
    pageIdRef.current = pageId;
  }, [pageId]);

  useEffect(() => {
    if (items.length > 0) {
      const handler = (e) => {
        e.preventDefault();
        switchPage(e.key, { pageId: pageIdRef.current, total: items.length - 1 }, redir.current);
      };
      document.addEventListener('keyup', handler);
    }
  }, [items.length]);

  const currentPage =
    [pages, items].every(({ length }) => length > 0) && pages.find(({ upID }) => upID === items[pageId].upID);

    return (
    <section className="retain container">
      {items.length > 0 && chapters.length > 0 && (
        <Sidebar
          items={items}
          currentPage={currentPage}
          image={chapters.find(({ chapterID }) => +chapterID === +chapterId).chapterImage}
          onClick={(i) => {
            switchPage(null, { pageId: i, total: items.length - 1 }, redir.current);
          }}
        />
      )}
      {currentPage !== false && (
        <RetainContent
          appId={DataHandler.matchAppIdSync()}
          image={appContent(currentPage.image)}
          summary={{
            title: currentPage.title,
            text: renderHTML(currentPage.summary || ''),
          }}
          params={currentPage}
          key={currentPage.upID}
        />
      )}
      {redirect && <Redirect push to={redirect} />}
    </section>
  );
};

export default RetainContentView;
